/* eslint-disable @next/next/no-img-element */
import React, { useMemo } from 'react'

import type {
  CategoryWithChildren,
  CategoryWithParentCategory,
  StoryWithKeyIndicatorsCategoriesStoryImageAndResources,
} from '@aqua/db/types'

import { useStory } from '~/hooks/story/useStory'
import StoryCardBadges from '../story-card-components/StoryCardBadges'
import StoryCardCountryAndYear from '../story-card-components/StoryCardCountryAndYear'
import StoryCardStats from '../story-card-components/StoryCardStats'
import StoryCardStatsMobile from '../story-card-components/StoryCardStatsMobile'
import StoryCardSummary from '../story-card-components/StoryCardSummary'

interface StoryHeaderPropType {
  storyData: StoryWithKeyIndicatorsCategoriesStoryImageAndResources
  innerMostCategory?: {
    storyId: number
    type: CategoryWithParentCategory | undefined
  }
  categoryData: CategoryWithChildren[]
}

const StoryHeader = ({
  storyData,
  categoryData,
  innerMostCategory,
}: StoryHeaderPropType) => {
  const {
    change,
    sign,
    indicator,
    country,
    highlightedCategory,
    indicatorIcon,
    indicatorCategory,
    yearRange: { startYear, endYear },
  } = useStory(storyData, categoryData)

  const variable = indicator?.variableName
  const indicatorWithoutShowCase = storyData?.storyKeyIndicators?.filter(
    (x) => !x.showcase,
  )

  const indicatorTags = useMemo(
    () =>
      indicatorWithoutShowCase?.map((x) => {
        const child = indicatorCategory
          ?.find(
            (option) =>
              option?.children?.some((child) => child?.id === x?.type),
          )
          ?.children?.find((child) => child.id === x?.type)
        return {
          name: child?.name,
        }
      }),
    [indicatorWithoutShowCase, indicatorCategory],
  )

  return (
    <div className='flex w-full flex-col bg-white'>
      <div className=' mb-2 flex w-full cursor-pointer rounded bg-white'>
        <StoryCardStats
          innerMostCategory={innerMostCategory}
          sign={sign}
          storyImage={indicatorIcon}
          change={change}
          variable={variable}
          indicator={indicator}
        />
        <div className='flex w-full flex-col '>
          <StoryCardStatsMobile
            innerMostCategory={innerMostCategory}
            storyImage={indicatorIcon}
            sign={sign}
            change={change}
            variable={variable}
            indicator={indicator}
            country={country}
            startYear={startYear}
            endYear={endYear}
          />
          <div className='flex w-full px-6 py-5'>
            <StoryCardSummary
              summary={
                storyData.summary ? storyData.summary : 'No Summary Added'
              }
            />
            <StoryCardCountryAndYear
              country={country}
              startYear={startYear}
              endYear={endYear}
            />
          </div>
        </div>
      </div>
      <div className='mt-4 flex h-max w-full flex-col items-center px-6'>
        <img
          src={storyData.storyImage?.image}
          alt={storyData.storyImage?.description ?? ''}
          className='h-auto'
        />
      </div>
      <StoryCardBadges
        innerMostCategory={innerMostCategory}
        storyChild={highlightedCategory}
        storyData={storyData}
        isStoryPage
        indicatorTags={indicatorTags}
      />
    </div>
  )
}

export default StoryHeader
